import React from 'react';
import { Button, Grid, GridCell, Heading, Text } from '@flixbus/honeycomb-react';
import { useTranslation } from 'react-i18next';

const ErrorMessage = () => {
    const { t } = useTranslation();

    return (
        <Grid extraClasses="hcr-space-8-top">
            <GridCell colSpan={12} extraClasses="hcr-has-text-centered">
                <Heading size={2}>{t('errors.page.title')}</Heading>
                <Text>{t('errors.page.hint')}</Text>
                <Button appearance="primary" extraClasses="hcr-space-4-top" onClick={() => window.location.reload()}>
                    {t('buttons.reload')}
                </Button>
            </GridCell>
        </Grid>
    );
};

// Catches render errors only; event handler and API errors are shown as toasts (useErrorNotification).
class ErrorBoundary extends React.Component {
    state = { hasError: false };

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        console.error(error, info.componentStack);
    }

    render() {
        return this.state.hasError ? <ErrorMessage /> : this.props.children;
    }
}

export default ErrorBoundary;
